/* Montena — Área Profesional.
   Repetir pedido (reconstruye el carrito) + Mi kit habitual (guardado en el
   navegador). Sin apps: usa la AJAX Cart API (/cart/add.js). Todo defensivo
   porque el estado con sesión no se puede probar en el dev server. */
(function () {
  var KIT_KEY = window.MONTENA_KIT_KEY || 'montena_kit_v1_guest';

  function parseAttr(el, name) {
    try { return JSON.parse(el.getAttribute(name) || '[]'); } catch (e) { return []; }
  }

  // Añade una lista [{id, quantity}] al carrito. Intenta en bloque; si falla
  // (p. ej. algún producto agotado), lo intenta uno a uno y omite los fallidos.
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (res.ok) return { added: items.length, failed: 0 };
      throw new Error('bulk');
    }).catch(function () {
      var added = 0, failed = 0;
      return items.reduce(function (chain, it) {
        return chain.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [it] })
          }).then(function (r) { if (r.ok) { added++; } else { failed++; } })
            .catch(function () { failed++; });
        });
      }, Promise.resolve()).then(function () { return { added: added, failed: failed }; });
    });
  }

  function goToCartOrWarn(btn, original, result) {
    if (result.added > 0) {
      window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    } else {
      btn.disabled = false;
      btn.textContent = original;
      alert('No se pudieron añadir los productos. Puede que estén agotados ahora mismo.');
    }
  }

  /* ---------- Kit (localStorage) ---------- */
  function getKit() {
    try { return JSON.parse(localStorage.getItem(KIT_KEY) || '[]'); } catch (e) { return []; }
  }
  function setKit(kit) {
    try { localStorage.setItem(KIT_KEY, JSON.stringify(kit)); } catch (e) {}
    renderKit();
  }
  function changeQty(id, delta) {
    var kit = getKit();
    for (var i = 0; i < kit.length; i++) {
      if (kit[i].id === id) { kit[i].quantity = Math.max(1, (kit[i].quantity || 1) + delta); break; }
    }
    setKit(kit);
  }
  function removeItem(id) {
    setKit(getKit().filter(function (k) { return k.id !== id; }));
  }

  function addToKit(id, productTitle, variantTitle) {
    var title = productTitle;
    if (variantTitle && variantTitle !== 'Default Title') { title = productTitle + ' · ' + variantTitle; }
    var kit = getKit(), found = null;
    for (var i = 0; i < kit.length; i++) { if (kit[i].id === id) { found = kit[i]; break; } }
    if (found) { found.quantity = (found.quantity || 1) + 1; }
    else { kit.push({ id: id, quantity: 1, title: title }); }
    setKit(kit);
  }

  /* ---------- Buscador de catálogo -> añadir al kit ---------- */
  function searchProducts(term) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][fields]=title,product_type,variants.sku,variants.barcode,vendor';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return (j.resources && j.resources.results && j.resources.results.products) || [];
      }).catch(function () { return []; });
  }

  function renderResults(products, resEl) {
    resEl.innerHTML = '';
    if (!products.length) {
      var none = document.createElement('p');
      none.className = 'montena-area__kit-noresults';
      none.textContent = 'Sin resultados.';
      resEl.appendChild(none);
      return;
    }
    products.forEach(function (p) {
      var row = document.createElement('div');
      row.className = 'montena-area__result';

      var src = (p.featured_image && p.featured_image.url) || p.image || '';
      if (src) {
        var img = document.createElement('img');
        img.className = 'montena-area__result-img';
        img.src = src; img.alt = ''; img.loading = 'lazy';
        row.appendChild(img);
      }

      var name = document.createElement('span');
      name.className = 'montena-area__result-name';
      name.textContent = p.title;
      row.appendChild(name);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--small montena-area__result-add';
      btn.textContent = 'Añadir';
      btn.addEventListener('click', function () { addFromProduct(p.handle, p.title, row, btn); });
      row.appendChild(btn);

      resEl.appendChild(row);
    });
  }

  function addFromProduct(handle, title, row, btn) {
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '…';
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var variants = prod.variants || [];
        if (variants.length === 1) {
          addToKit(variants[0].id, title, variants[0].title);
          btn.textContent = 'Añadido ✓';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
        } else {
          showVariantPicker(row, prod, title, btn, orig);
        }
      }).catch(function () { btn.textContent = orig; btn.disabled = false; });
  }

  function showVariantPicker(row, prod, title, btn, orig) {
    btn.disabled = false; btn.textContent = orig;
    if (row.querySelector('.montena-area__result-variant')) return;
    var wrap = document.createElement('div');
    wrap.className = 'montena-area__result-variant';

    var sel = document.createElement('select');
    sel.className = 'montena-area__result-select';
    (prod.variants || []).forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.title + (v.available ? '' : ' (agotado)');
      sel.appendChild(o);
    });

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'button button--small';
    add.textContent = 'Añadir tono';
    add.addEventListener('click', function () {
      var vid = parseInt(sel.value, 10);
      var vt = sel.options[sel.selectedIndex].textContent.replace(' (agotado)', '');
      addToKit(vid, title, vt);
      add.textContent = 'Añadido ✓';
      setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 1200);
    });

    wrap.appendChild(sel);
    wrap.appendChild(add);
    row.appendChild(wrap);
  }

  function renderKit() {
    var list = document.getElementById('montena-kit-list');
    var empty = document.getElementById('montena-kit-empty');
    var actions = document.getElementById('montena-kit-actions');
    if (!list) return;
    var kit = getKit();
    if (!kit.length) {
      if (empty) empty.style.display = '';
      list.style.display = 'none';
      list.innerHTML = '';
      if (actions) actions.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (actions) actions.style.display = '';
    list.style.display = '';
    list.innerHTML = '';
    kit.forEach(function (k) {
      var li = document.createElement('li');
      li.className = 'montena-area__kit-item';

      var name = document.createElement('span');
      name.className = 'montena-area__kit-name';
      name.textContent = k.title || ('Producto ' + k.id);

      var qty = document.createElement('span');
      qty.className = 'montena-area__kit-qty';
      var dec = document.createElement('button');
      dec.type = 'button'; dec.textContent = '−'; dec.setAttribute('aria-label', 'Restar una unidad');
      var num = document.createElement('span'); num.textContent = k.quantity;
      var inc = document.createElement('button');
      inc.type = 'button'; inc.textContent = '+'; inc.setAttribute('aria-label', 'Sumar una unidad');
      dec.addEventListener('click', function () { changeQty(k.id, -1); });
      inc.addEventListener('click', function () { changeQty(k.id, 1); });
      qty.appendChild(dec); qty.appendChild(num); qty.appendChild(inc);

      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'montena-area__kit-remove';
      rm.textContent = 'Quitar'; rm.setAttribute('aria-label', 'Quitar del kit');
      rm.addEventListener('click', function () { removeItem(k.id); });

      li.appendChild(name); li.appendChild(qty); li.appendChild(rm);
      list.appendChild(li);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderKit();

    /* Buscador del kit */
    var q = document.getElementById('montena-kit-q');
    var res = document.getElementById('montena-kit-results');
    if (q && res) {
      var timer;
      q.addEventListener('input', function () {
        clearTimeout(timer);
        var term = q.value.trim();
        if (term.length < 2) { res.innerHTML = ''; return; }
        timer = setTimeout(function () {
          searchProducts(term).then(function (products) { renderResults(products, res); });
        }, 250);
      });
    }

    /* Repetir pedido */
    document.querySelectorAll('[data-montena-reorder]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items = parseAttr(btn, 'data-items');
        if (!items.length) return;
        var original = btn.textContent;
        btn.disabled = true; btn.textContent = 'Añadiendo…';
        addItems(items).then(function (r) { goToCartOrWarn(btn, original, r); });
      });
    });

    /* Guardar pedido como kit */
    document.querySelectorAll('[data-montena-savekit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items = parseAttr(btn, 'data-items');
        var titles = parseAttr(btn, 'data-titles');
        if (!items.length) return;
        var kit = getKit();
        items.forEach(function (it, idx) {
          var found = null;
          for (var i = 0; i < kit.length; i++) { if (kit[i].id === it.id) { found = kit[i]; break; } }
          if (found) { found.quantity = it.quantity; }
          else { kit.push({ id: it.id, quantity: it.quantity, title: titles[idx] || ('Producto ' + it.id) }); }
        });
        setKit(kit);
        var original = btn.textContent;
        btn.textContent = 'Guardado en tu kit ✓';
        setTimeout(function () { btn.textContent = original; }, 2000);
        var kitEl = document.getElementById('montena-area-kit');
        if (kitEl) kitEl.scrollIntoView({ behavior: 'smooth' });
      });
    });

    /* Añadir todo el kit al carrito */
    var addAll = document.getElementById('montena-kit-addall');
    if (addAll) {
      addAll.addEventListener('click', function () {
        var kit = getKit();
        if (!kit.length) return;
        var items = kit.map(function (k) { return { id: k.id, quantity: k.quantity }; });
        var original = addAll.textContent;
        addAll.disabled = true; addAll.textContent = 'Añadiendo…';
        addItems(items).then(function (r) { goToCartOrWarn(addAll, original, r); });
      });
    }
  });
})();
